/**
 * Magniberg: load a product card's second image before it is hovered.
 *
 * Horizon shows the second image when the pointer enters a card, but that image is
 * lazy-loaded and only starts downloading at that moment, so it appears with a delay.
 * This starts the download as soon as a card comes near the screen, at low priority,
 * so the swap on hover is immediate. Only on devices that can hover.
 */
const SECOND_IMAGE = 'slideshow-slide:nth-of-type(2) img[loading="lazy"]';

if (window.matchMedia('(hover: hover)').matches && 'IntersectionObserver' in window) {
  const visibility = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        visibility.unobserve(entry.target);
        const image = entry.target.querySelector(SECOND_IMAGE);
        if (image instanceof HTMLImageElement) {
          image.setAttribute('fetchpriority', 'low');
          image.removeAttribute('loading');
        }
      }
    },
    { rootMargin: '300px 0px' }
  );

  /** @param {ParentNode} root */
  const observeCards = (root) => {
    for (const card of root.querySelectorAll('product-card')) visibility.observe(card);
  };

  observeCards(document);

  // Cards added later: infinite scroll, filtering, recommendations.
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('product-card')) visibility.observe(node);
        else observeCards(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
